import { useCallback } from "react"
import { I18n } from "utils/i18n-shim"

import useConfirm from "hooks/useConfirm"
import { useDeleteActivityNote } from "entities/activity-note"
import useHandleServerErrors from "hooks/useHandleServerErrors"

export const useHandleDeleteActivityNote = () => {
  const deleteActivityNote = useDeleteActivityNote()
  const handleServerErrors = useHandleServerErrors()
  const confirm = useConfirm()

  return useCallback(
    (activityNote) => {
      confirm(
        I18n.t("activity-notes.delete.sure", {
          entity: activityNote.creator.name
        }),
        {
          title: I18n.t("activities.delete-note"),
          onConfirm: () => {
            deleteActivityNote.mutate(activityNote.id, {
              onError: (error) => handleServerErrors(error)
            })
          },
          confirmBtnText: I18n.t("delete.title"),
          buttonSize: "large"
        }
      )
    },
    [confirm, deleteActivityNote, handleServerErrors]
  )
}
